export const ConsumerPhoneNumberViewUat = {
  header: 'workflow.consumerPhoneNumber.header',
  infoMessage: 'workflow.consumerPhoneNumber.infoMessage'
}
